import authService from 'ApiService/Auth/AuthService';
import Card from 'components/card';
import InputField from 'components/fields/InputField';
import Centered from 'layouts/auth/types/Centered';
import ConfirmationModal from 'pages/Common/ConfirmationModal';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';

function ForgotPasswordCenter() {
  const [email, setEmail] = useState('');
  const [forgotPasswordPopup, setForgotPasswordPopup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const forgotPasswordResetRequest = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      const response = await authService.forgetPassword(email);
      if (response.data.success) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message || 'Failed to update the batch');
      }
    } catch (error) {
      console.error(
        'Error updating batch:',
        error.response?.data || error.message
      );
      toast.error(
        error.response?.data?.message ||
          'An error occurred while updating the batch'
      );
    } finally {
      setForgotPasswordPopup(false);
      setIsSubmitting(false);
    }
  };

  const hanldeRequest = () => {
    if (!email) {
      toast.error('Email is required.');
    } else {
      setForgotPasswordPopup(true);
    }
  };
  return (
    <Centered
      maincard={
        <Card
          extra={
            'max-w-[405px] md:max-w-[550px] h-max mt-32 md:mt-[120px] mx-2.5 md:mx-auto mb-auto pb-2.5 pt-8 md:pt-2.5 px-4 md:!p-[50px]'
          }
        >
          <Link to="/auth/sign-in" className="mt-0 w-max lg:pb-6">
            <div className="mx-auto flex h-fit w-fit items-center hover:cursor-pointer">
              <svg
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.70994 2.11997L2.82994 5.99997L6.70994 9.87997C7.09994 10.27 7.09994 10.9 6.70994 11.29C6.31994 11.68 5.68994 11.68 5.29994 11.29L0.709941 6.69997C0.319941 6.30997 0.319941 5.67997 0.709941 5.28997L5.29994 0.699971C5.68994 0.309971 6.31994 0.309971 6.70994 0.699971C7.08994 1.08997 7.09994 1.72997 6.70994 2.11997V2.11997Z"
                  fill="#A3AED0"
                />
              </svg>
              <p className="ml-3 text-sm text-gray-600">Back to Sign In</p>
            </div>
          </Link>
          <h3 className="mb-[30px] text-center text-4xl font-bold text-gray-900 dark:text-white">
            Awdiz Institute
          </h3>
          <p className="mb-2 text-2xl font-bold text-navy-700 dark:text-white">
            Forgot Your Password?
          </p>
          <p className="mb-6 ml-1 mt-[10px] text-base text-gray-600">
            No problem. Just let us know your email address and we'll request it
            to administrator.
          </p>
          {/* Email */}
          <InputField
            maxLength={100}
            variant="auth"
            label="Email*"
            placeholder="mail@simmmple.com"
            id="email"
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {/* button */}
          <button
            type="submit"
            onClick={hanldeRequest}
            className="mt-4 w-full rounded-xl bg-brand-500 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            {isSubmitting ? 'Loading..' : 'Email password reset request'}
          </button>
          {/* Update Confirmation Modal */}
          <ConfirmationModal
            isOpen={forgotPasswordPopup}
            onClose={() => {
              if (!isSubmitting) {
                setForgotPasswordPopup(false);
              }
            }}
            onConfirm={forgotPasswordResetRequest}
            title="Forgot Password Request" // More concise and standard
            message="Are you sure you want to request a password reset from the administrator?" // Clearer phrasing
            confirmText={isSubmitting ? 'Processing...' : 'Yes, Confirm'}
            cancelText="Cancel"
            icon="info"
            disableConfirm={isSubmitting}
          />
        </Card>
      }
    />
  );
}

export default ForgotPasswordCenter;
